/**
* Copyright (c) 2018 Microsoft Corporation
* Modules Registration
* THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
*/

export const componentDictionary = {};

componentDictionary['__local__|__local__|shared|components|cartlineitem'] = {
                c: () => require('partner/shared/components/cartlineitem.component.tsx'),
                cn: '__local__-__local__-cartlineitem'
            };
componentDictionary['__local__|__local__|shared|components|modal-panel'] = {
                c: () => require('partner/shared/components/modal-panel.component.tsx'),
                cn: '__local__-__local__-modal-panel'
            };
componentDictionary['__local__|__local__|shared|components|modal'] = {
                c: () => require('partner/shared/components/modal.component.tsx'),
                cn: '__local__-__local__-modal'
            };
componentDictionary['__local__|__local__|shared|components|price'] = {
                c: () => require('partner/shared/components/price.component.tsx'),
                cn: '__local__-__local__-price'
            };
componentDictionary['__local__|__local__|shared|components|product-label'] = {
                c: () => require('partner/shared/components/product-label.component.tsx'),
                cn: '__local__-__local__-product-label'
            };
componentDictionary['__local__|__local__|shared|components|product'] = {
                c: () => require('partner/shared/components/product.component.tsx'),
                cn: '__local__-__local__-product'
            };
componentDictionary['__local__|__local__|shared|components|promocode'] = {
                c: () => require('partner/shared/components/promocode.component.tsx'),
                cn: '__local__-__local__-promocode'
            };
componentDictionary['__local__|__local__|themes|only|views|components|addtowishlist'] = {
                c: () => require('partner/themes/only/views/components/addtowishlist.component.tsx'),
                cn: '__local__-__local__-addtowishlist'
            };
componentDictionary['__local__|__local__|themes|only|views|components|carticon'] = {
                c: () => require('partner/themes/only/views/components/carticon.component.tsx'),
                cn: '__local__-__local__-carticon'
            };
componentDictionary['__local__|__local__|themes|only|views|components|cartlineitem'] = {
                c: () => require('partner/themes/only/views/components/cartlineitem.component.tsx'),
                cn: '__local__-__local__-cartlineitem'
            };
componentDictionary['__local__|__local__|themes|only|views|components|price'] = {
                c: () => require('partner/themes/only/views/components/price.component.tsx'),
                cn: '__local__-__local__-price'
            };
componentDictionary['__local__|__local__|themes|only|views|components|product-v2'] = {
                c: () => require('partner/themes/only/views/components/product-v2.component.tsx'),
                cn: '__local__-__local__-product-v2'
            };
componentDictionary['__local__|__local__|themes|only|views|components|product'] = {
                c: () => require('partner/themes/only/views/components/product.component.tsx'),
                cn: '__local__-__local__-product'
            };
componentDictionary['__local__|__local__|themes|only|views|components|promocode'] = {
                c: () => require('partner/themes/only/views/components/promocode.component.tsx'),
                cn: '__local__-__local__-promocode'
            };
componentDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|components|order-history-with-search-and-filters-header'] = {
                c: () => require('@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/components/order-history-with-search-and-filters-header.component.js'),
                cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-header'
            };
componentDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|components|order-history-with-search-and-filters-order-list'] = {
                c: () => require('@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/components/order-history-with-search-and-filters-order-list.component.js'),
                cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-order-list'
            };
componentDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|components|order-history-with-search-and-filters-order-table'] = {
                c: () => require('@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/components/order-history-with-search-and-filters-order-table.component.js'),
                cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-order-table'
            };
componentDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|components|order-history-with-search-and-filters-organization-wide-selector'] = {
                c: () => require('@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/components/order-history-with-search-and-filters-organization-wide-selector.component.js'),
                cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-organization-wide-selector'
            };
componentDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|components|order-history-with-search-and-filters-view-mode-selector'] = {
                c: () => require('@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/components/order-history-with-search-and-filters-view-mode-selector.component.js'),
                cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters-view-mode-selector'
            };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|carticon'] = {
                c: () => require('@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/carticon.component.js'),
                cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-carticon'
            };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|cartlineitem'] = {
                c: () => require('@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/cartlineitem.component.js'),
                cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-cartlineitem'
            };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|product-v2'] = {
                c: () => require('@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/product-v2.component.js'),
                cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-product-v2'
            };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|product'] = {
                c: () => require('@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/product.component.js'),
                cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-product'
            };
componentDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|components|promocode'] = {
                c: () => require('@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/components/promocode.component.js'),
                cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-promocode'
            };